module.exports = __webpack_public_path__ + "static/media/6-8.78a2bb28.webp";